import type { ModalFunc } from 'ant-design-vue/es/modal/Modal';
import { useConfirm } from '@inn/components';
import { usePermitStore } from '@/storage/permits';
import { useProfileStore } from '@/storage/profile';

type PermitsReloadConfirmType = 'site' | 'base' | 'owns' | 'sse';
let confirmInstance: ReturnType<ModalFunc>;
export function usePermitChangeConfirm(
  type: PermitsReloadConfirmType,
  callback?: () => any | Promise<any>,
) {
  if (confirmInstance && type === 'sse') {
    confirmInstance?.destroy?.();
  }
  const permits = usePermitStore();
  const profile = useProfileStore();
  const label: Record<'site' | 'base' | 'owns', string> = {
    site: '站点',
    base: '基础',
    owns: '您的',
  };
  const content =
    type === 'sse'
      ? '您的权限已被管理员更新，您须要重载页面权限。'
      : `${label[type]}权限信息发生改变，马上重载页面?`;
  confirmInstance = useConfirm('info', {
    content,
    cancelButton: type !== 'sse',
    onOk: async () => {
      if (type !== 'sse') {
        await profile.reload();
        await permits.reload();
      }
      await callback?.();
    },
  });
  return confirmInstance;
}
